export default "__VITE_ASSET__CIVDqy4i__"